<script setup lang="ts">
import type { PreOrderItem } from "@/schemas/pre-order";

const { myPreOrders, isLoading, status, error } = useMyPreOrders();
const columns: TableColumn<PreOrderItem>[] = [
  { key: "product", label: "Produit" },
  { key: "order_id", label: "Commande", width: "128px", verticalAlign: "middle", mobileFullWidth: true },
  { key: "date", label: "Disponibilité", horizontalAlign: "right", verticalAlign: "middle", mobileFullWidth: true },
];
</script>

<template>
  <UiDefaultPage title="Pré-commandes">
    <UiQueryWrapper :is-loading="isLoading" :status="status" :error="error">
      <UiEmptyResult v-if="!myPreOrders.items.length" title="Aucune pré-commande" />
      <UiResponsiveTable v-else :columns="columns" :data="myPreOrders.items">
        <template #product-cell="{ row }">
          <ProductListItem :product="row.product" />
        </template>
        <template #order_id-cell="{ row }">
          <OrderLink :order-id="row.order_id" />
        </template>
        <template #date-cell="{ row }">
          <div v-if="row.product.pre_order_timestamp">
            {{ date(row.product.pre_order_timestamp) }}
          </div>
        </template>
      </UiResponsiveTable>
    </UiQueryWrapper>
  </UiDefaultPage>
</template>
